import { fetchData } from "@client";

export async function getPaymentHistoryQuery(id = null) {
  try {
    const res = await fetchData(
      `v2/order?limit=8${id ? "&starting_after=" + id : ""}`
    );
    return res.paymentHistory;//?.filter(p => p.detail?.length);
  } catch (e) {
    return [];
  }
}
